import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { PricingConfigurationValues } from '@/services/Pricing/pricing-configuration.service';
import { computeNextValues } from './pricingConfigUtils';
import { formRowsToValues } from './pricingFormMapping';

type SubmitPromise = { unwrap: () => Promise<unknown> };

type UsePricingFormParams = {
  baseline: PricingConfigurationValues;
  existing: PricingConfigurationValues | undefined;
  submit: (nextValues: PricingConfigurationValues) => SubmitPromise;
  messages: { success: string; error: string };
};

export function usePricingForm({ baseline, existing, submit, messages }: UsePricingFormParams) {
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const fallbackCountry = Object.keys(existing ?? {})[0] ?? Object.keys(baseline)[0] ?? '';
  const activeCountry = selectedCountry ?? fallbackCountry;

  const submitHandler = (data: Record<string, any>) => {
    if (!activeCountry) return;
    const values = formRowsToValues(data.rows ?? []);
    const activeValues = values[activeCountry];
    if (!activeValues) return;

    const nextValues = computeNextValues(existing, baseline, activeCountry, activeValues);

    submit(nextValues)
      .unwrap()
      .then(() => toast.success(messages.success))
      .catch(() => toast.error(messages.error));
  };

  return { activeCountry, setActiveCountry: setSelectedCountry, submitHandler };
}
